const SvgComponent = () => {
  return (
    <svg
      width="16"
      height="20"
      viewBox="0 0 16 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.5 2V1.5H14H4C3.33696 1.5 2.70107 1.76339 2.23223 2.23223C1.76339 2.70107 1.5 3.33696 1.5 4V12.56V13.4445L2.25785 12.9884C2.78429 12.6715 3.38657 12.5028 4.001 12.5H14H14.5V12V2ZM14.5 14V13.5H14H4C3.33696 13.5 2.70107 13.7634 2.23223 14.2322C1.76339 14.7011 1.5 15.337 1.5 16C1.5 16.663 1.76339 17.2989 2.23223 17.7678C2.70107 18.2366 3.33696 18.5 4 18.5H14H14.5V18V14ZM4 0.5H14C14.3978 0.5 14.7794 0.658035 15.0607 0.93934C15.342 1.22064 15.5 1.60218 15.5 2V18C15.5 18.3978 15.342 18.7794 15.0607 19.0607C14.7794 19.342 14.3978 19.5 14 19.5H4C3.07174 19.5 2.1815 19.1313 1.52513 18.4749C0.868749 17.8185 0.5 16.9283 0.5 16V4C0.5 3.07174 0.868749 2.1815 1.52513 1.52513C2.1815 0.868749 3.07174 0.5 4 0.5ZM10 5.5H6C5.86739 5.5 5.74022 5.44732 5.64645 5.35355C5.55268 5.25978 5.5 5.13261 5.5 5C5.5 4.86739 5.55268 4.74022 5.64645 4.64645C5.74022 4.55268 5.86739 4.5 6 4.5H10C10.1326 4.5 10.2598 4.55268 10.3536 4.64645C10.4473 4.74022 10.5 4.86739 10.5 5C10.5 5.13261 10.4473 5.25978 10.3536 5.35355C10.2598 5.44732 10.1326 5.5 10 5.5Z"
        fill="black"
        stroke="#101010"
      />
    </svg>
  )
}

export default SvgComponent
